import React from 'react';

const Note = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33317 1.66663H16.6665C17.5832 1.66663 18.3332 2.41663 18.3332 3.33329V13.3333C18.3332 14.25 17.5832 15 16.6665 15H4.99984L1.6665 18.3333V3.33329C1.6665 2.41663 2.4165 1.66663 3.33317 1.66663ZM4.30817 13.3333H16.6665V3.33329H3.33317V14.3083L4.30817 13.3333ZM9.1665 9.99996H10.8332V11.6666H9.1665V9.99996ZM10.8332 4.99996H9.1665V8.33329H10.8332V4.99996Z"
      fill="#9775FA"
    />
  </svg>
);

export default Note;
